/**
 * A/B Test — Cart drawer trust elements (payment icons)
 * Toggle: body[data-cart-trust-elements-ab="true|false"]
 *   - true  (Variant B / test)    -> show payment icons below checkout
 *   - false (Variant A / control) -> hide payment icons
 */
(function () {
  'use strict';

  var ATTR = 'data-cart-trust-elements-ab';
  var refreshTimer = null;

  function isAbEnabled() {
    return document.body.getAttribute(ATTR) === 'true' ||
      document.documentElement.getAttribute(ATTR) === 'true';
  }

  function updateVisibility() {
    var enabled = isAbEnabled();
    document.querySelectorAll('cart-drawer .cart-drawer__trust-elements').forEach(function (el) {
      el.hidden = !enabled;
      el.classList.toggle('is-visible', enabled);
    });
  }

  function scheduleUpdate() {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(updateVisibility, 0);
  }

  function observeCartDrawer(drawer) {
    if (!drawer || drawer._trustElementsObserved) return;
    drawer._trustElementsObserved = true;

    new MutationObserver(scheduleUpdate).observe(drawer, {
      childList: true,
      subtree: true
    });
  }

  function init() {
    updateVisibility();

    var bodyObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.attributeName === ATTR) updateVisibility();
      });
    });
    bodyObserver.observe(document.body, { attributes: true, attributeFilter: [ATTR] });
    bodyObserver.observe(document.documentElement, { attributes: true, attributeFilter: [ATTR] });

    document.querySelectorAll('cart-drawer').forEach(observeCartDrawer);

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('cart-drawer')) {
            observeCartDrawer(node);
            scheduleUpdate();
          } else if (node.querySelectorAll) {
            node.querySelectorAll('cart-drawer').forEach(observeCartDrawer);
          }
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });

    document.addEventListener('cart:change', scheduleUpdate);
    document.addEventListener('cart:refresh', scheduleUpdate);
    document.addEventListener('variant:add', scheduleUpdate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.AerlessCartTrustElementsAb = {
    refresh: updateVisibility,
    isEnabled: isAbEnabled
  };
})();
